import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./index.scss";
import bgShape from "../../../assets/images/bg-group.png";
import { useTranslation } from "../../../hooks/useTranslation";

const GroupeSection = () => {
  const { t } = useTranslation();

  return (
    <section className="groupe-section py-5 " id="filiales">
      <Container>
        <Row className="align-items-center">
          {/* Colonne gauche */}
          <Col lg={5} className="text-left mb-4 mb-md-0">
            <h2 className="groupe-title">
              <span>{t('groupeTitle')}</span>
              <br />{t('groupeSubtitle')}
            </h2>
            <p className="groupe-subtext">
              {t('groupeDescription')}
            </p>
          </Col>

          {/* Colonne droite */}
          <Col lg={7}>
            <div
              className="groupe-grid"
              style={{ backgroundImage: `url(${bgShape})` }}>
              <Card className="groupe-card mt-5 ms-5">
                <h3>{t('spotinTitle')}</h3>
                <ul>
                  <li>
                    {t('spotinDescription')}
                  </li>
                </ul>
              </Card>

              <Card className="groupe-card mt-5 ">
                <h3>{t('buzztrackTitle')}</h3>
                <ul>
                  <li>
                    {t('buzztrackDescription')}
                  </li>
                </ul>
              </Card>

              <Card className="groupe-card ms-5">
                <h3>{t('msitConseilTitle')}</h3>
                <ul>
                  <li>
                    {t('msitConseilDescription')}
                  </li>
                </ul>
              </Card>

              <Card className="groupe-card ">
                <h3>{t('matoisTitle')}</h3>
                <ul>
                  <li>
                    {t('matoisDescription')}
                  </li>
                </ul>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default GroupeSection;
